import React, { useCallback } from 'react';
import 'pages/Gallery/Gallery.css';
import useGalleryData from 'pages/Gallery/hooks/useGalleryData';
import LoadingView from 'components/LoadingView';
import { useModal } from 'modules/Modal/ModalProvider';
import Gallery from 'react-photo-gallery';

function GalleryView() {
    const { openImageModal } = useModal();
    const [data, loading] = useGalleryData();

    const renderImage = useCallback(
        ({ photo }) => {
            const { src, height, width } = photo || {};
            return (
                <img
                    data-aos="zoom-out-up"
                    alt={'dog'}
                    style={{ objectFit: 'cover', margin: 8, borderRadius: 8, cursor: 'pointer' }}
                    src={src}
                    height={height}
                    width={width}
                    onClick={() => openImageModal(src)}
                />
            );
        },
        [openImageModal]
    );

    if (loading) return <LoadingView />;
    return (
        <section className={'gallery'}>
            <div className={'gallery-content'}>
                <Gallery photos={data} margin={8} renderImage={renderImage} />
            </div>
        </section>
    );
}

export default GalleryView;
